const reasignaciondeoperadores = {
  ObtenSesionesDeLasAudiencias: 'Forseti/ReasignacionDeOperadores/GetSesionesDeLasAudiencias',
  GuardarOperadorDeLaSesion: 'Forseti/ReasignacionDeOperadores/GuardarOperadorDeLaSesion'
}

const asignacionDePermisosParaVerEnVivo = {
  GetAudienciasAgendadas: 'Forseti/AsignacionDePermisosParaVerEnVivo/GetAudienciasAgendadas',
  GetAudiencia: 'Forseti/AsignacionDePermisosParaVerEnVivo/GetAudiencia',
  BusquedaDePersonas: 'Forseti/AsignacionDePermisosParaVerEnVivo/BusquedaDePersonas',
  GuardarPermiso: 'Forseti/AsignacionDePermisosParaVerEnVivo/GuardarPermiso',
  EliminararPermisoParaVerEnvivo: 'Forseti/AsignacionDePermisosParaVerEnVivo/EliminararPermisoParaVerEnvivo'
}

const entregadetoken = {
  GetAudiencias: 'Forseti/EntregaDeToken/GetAudiencias',
  GetAudiencia: 'Forseti/EntregaDeToken/GetAudiencia',
  GuardaLaPersonaQueRecogioElToken : 'Forseti/EntregaDeToken/GuardaLaPersonaQueRecogioElToken'
}

const paneldevigencias = {
  GetAudiencias: 'Forseti/PanelDeVigencias/GetAudiencias',
  GuardaNuevaVigencia: 'Forseti/PanelDeVigencias/GuardaNuevaVigencia',
}

const administracion = {
  reasignaciondeoperadores: reasignaciondeoperadores,
  asignacionDePermisosParaVerEnVivo: asignacionDePermisosParaVerEnVivo,
  entregadetoken: entregadetoken,
  paneldevigencias: paneldevigencias
}

export default administracion;



//////////////////
// WEBPACK FOOTER
// ./static/js/api/forseti/sistema/administracion/administracion.js
// module id = null
// module chunks = 